import expServiceProvider, { ExpressionLanguage } from '../ruleengine/expr/api';
import JEXLExpressionBuilder from '../ruleengine/expr/jexl/JEXLExpressionBuilder';
import JEXLService from '../ruleengine/expr/jexl/JEXLService';
import SpELExpressionBuilder from '../ruleengine/expr/spel/SpELExpressionBuilder';
import SpELService from '../ruleengine/expr/spel/SpELService';

class ExpEngine {
  private static instance: ExpEngine;

  private initialized: boolean = false;

  private constructor() {}

  static getInstance(): ExpEngine {
    if (!ExpEngine.instance) {
      ExpEngine.instance = new ExpEngine();
    }
    return ExpEngine.instance;
  }

  initialize = (language: ExpressionLanguage) => {
    switch (language) {
      case ExpressionLanguage.SPEL:
        expServiceProvider.setExpService(SpELService);
        expServiceProvider.setExpressionBuilder(SpELExpressionBuilder);
        break;
      case ExpressionLanguage.JEXL:
        expServiceProvider.setExpService(JEXLService);
        expServiceProvider.setExpressionBuilder(JEXLExpressionBuilder);
        break;
      default:
        throw new Error(`Unsupported expression language: ${language}`);
    }
    this.initialized = true;
  };

  reset = () => {
    this.initialized = false;
    expServiceProvider.setExpService(undefined);
    expServiceProvider.setExpressionBuilder(undefined);
  };

  isInitialized(): boolean {
    return this.initialized;
  }
}

const expEngine = ExpEngine.getInstance();

export default expEngine;
